import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

import AppLoader from '../components/appLoader/AppLoader';
import storeManager from '../store/StoreManager';

const renderingService = {
    async renderApp(store = storeManager.getStore()) {
        return new Promise((resolve) => {
            ReactDOM.render(
                <AppLoader store={store} />,
                document.getElementById('wrapper'),
                node => resolve(node)
            );
        });
    },

    configureAppRootForModal() {
        Modal.setAppElement('#wrapper');
    },
};

export default renderingService;
